export default "__VITE_ASSET__BciXk8O4__"